// Library Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { BsFillEyeFill } from "react-icons/bs";
import { FaStar, FaUserCircle } from "react-icons/fa";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Modal, Button, Tooltip, OverlayTrigger } from "react-bootstrap";

// Utils Imports
import { logout } from "../../actions/AppActions";
import formatDate from "../../Auxiliar/formatDate";
import { get, post } from "../../Services/api";
import Search from "../ReusableComponents/Search";
import { Pagination } from '@material-ui/lab';
import Attention from "../ReusableComponents/Attention";
import DefaultButton from "../ReusableComponents/DefaultButton";
import { MdRateReview, MdSaveAlt } from "react-icons/md";
import { RiSendPlaneLine } from "react-icons/ri";
import SweetAlert from "react-bootstrap-sweetalert";
import { PreferencesContext } from '../../contexts/PreferencesContext';
import StatusBadge, { getApprovalStatus } from "../ReusableComponents/StatusBadge";
import WorkQueueItem from '../ReusableComponents/WorkQueueItem';

const SuccessModal = ({ show, handleClose, handleTableUpdate, t }) => (
  <SweetAlert
          success
          title={t('success')}
          onConfirm={() => {
            handleClose();
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            handleClose();

          }}
          show={show}
          confirmBtnText='Ok'
          confirmBtnBsStyle="success"

        >
          {t('success_question_reviewed')}
        </SweetAlert>
);

class AvaliarQuestoes extends Component {
  static contextType = PreferencesContext;
  constructor(props) {
    super(props);
    this.state = {
      demandas: [],
      questoes: [],
      loading: true,
      redirect: false,
      categoria: null,
      demanda: null,
      pagination: null,
      isModalOpen: false,
      novoComentario: "",
      status: "",
      comentarios: [],
      isCommentsLoading: false,
      showSuccessModal: false,
      questao: {},
      isModalLoading: false,
      search: '',
      statusMsg:'',
      loadingStatus:false,
      loadingAddComent:false,
      statusFilter:'all'
    };
  }

  componentDidMount() {
    this.fetchQuestoes();
  }

  fetchQuestoes = async (page = 1, search = '') => {
    try {
      const { token } = this.props;
      const resp = await get(
        `api/professor/get_all_questoes?search=${search}&page=${page}&status=${this.state.statusFilter}`,
        token
      );
      const questoesWithDemanda = resp.questoes;

      this.setState((prevState) => ({
        questoes: questoesWithDemanda,
        pagination: resp.pagination,
        loading: false
      }));
    } catch (error) {
      this.setState({ redirect: true });
    }
  };

  

  editStatusQuestao = async (status, questao_) => {
      const { token } = this.props;
      const id = questao_.id;
      this.setState({loadingStatus:true,statusMsg:''})
  
  
      let data = { edited: false }
      if (questao_.edited == true) {
        data.edited = true;
      }
      console.log(questao_, status)
      document.getElementById('text_enunciado').innerHTML = questao_.name;
      data.enunciado = questao_.name;
      data.content_enunciado = document.getElementById('text_enunciado').textContent;
      data.categoria_id = questao_.categoria.id;
  
      data.escolaridade = questao_.escolaridade;
      data.dificuldade = questao_.dificuldade;
      data.type_questao = questao_.type_questao;
  
  
      data.palavras_chaves = questao_.palavras_chaves;
  
      if (questao_.type_questao == 'simples') {
        data.alternativa_a = questao_.alternativas[0].name;
        data.numero_alternativa = questao_.alternativas.length;
        if (data.numero_alternativa >= 2) data.alternativa_b = questao_.alternativas[1].name;
        if (data.numero_alternativa >= 3) data.alternativa_c = questao_.alternativas[2].name;
        if (data.numero_alternativa >= 4) data.alternativa_d = questao_.alternativas[3].name;
        if (data.numero_alternativa >= 5) data.alternativa_e = questao_.alternativas[4].name;
  
        data.correta = questao_.correta;
      }
      else if (questao_.type_questao == 'conjunto') {
        let questoes = [...questao_.questoes];
        console.log(questoes)
        questoes = questoes.map((item, id) => {
          item = { ...item };
          item.numero_alternativa = item.alternativas.length;
          item.alternativa_a = item.alternativas[0].name;
          if (item.numero_alternativa >= 2) item.alternativa_b = item.alternativas[1].name;
          if (item.numero_alternativa >= 3) item.alternativa_c = item.alternativas[2].name;
          if (item.numero_alternativa >= 4) item.alternativa_d = item.alternativas[3].name;
          if (item.numero_alternativa >= 5) item.alternativa_e = item.alternativas[4].name;
  
  
  
          delete item.alternativas;
          item.categoria_id = item.categoria.id;
          delete item.categoria;
          return item;
        });
        data.questoes = questoes;
      }
      else {
        //dissertiva nao precisa de mais nada, apenas enunciado
      }
      data.questao_id = id;
      console.log({ status, ...data })
      post(`api/professor/update_status_questao/${id}`, { status, ...data }, token).then((resp) => {
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token'); localStorage.removeItem('user');
          dispatchEvent(logout());
          this.props.logout();
          return;
        }
        if (resp.status==false) {
          this.setState({statusMsg:resp.message,loadingStatus:false})
        document.getElementById("avaliacao_header").scrollIntoView();

        }
        else {
          let questoes = this.state.questoes.map((item)=>{
            if(item.id==questao_.id){
              item.statusAprovacao=status;
              if(questao_.id==item.id){
                questao_={...item};
              }
            }
            return item;
          });
          this.setState({statusMsg:'',loadingStatus:false,showSuccessModal:true,questoes,questao:questao_})
        }
  
      }).catch((e) => {
        console.log(e)
        this.setState({loadingStatus:false})
  
      });
  };

  handleAddComentario = async (questaoId) => {
    const { token, user } = this.props;
    const { novoComentario } = this.state;
    this.setState({loadingAddComent:true});
    try {
      let resp = await post(
        "api/professor/store_comentario",
        { questao_id: questaoId, comentario: novoComentario },
        token
      );
      console.log(resp)
      if (resp.message == "Unauthenticated.") {
        localStorage.removeItem('token'); localStorage.removeItem('user');
        this.props.logout()
        return;
      }
      if (resp.status==false) {
        this.setState({statusMsg:resp.message,loadingAddComent:false});
        document.getElementById("avaliacao_header").scrollIntoView();

      }
      else {
        let questao = this.state.questao;
        let questoes = this.state.questoes.map((item)=>{
          if(item.id==questaoId){
            item.comentarios = [
              ...item.comentarios,
              {
                comentario: novoComentario,
                user_name: user.name,
                created_at: new Date().toISOString(),
              },
            ]
            if(questao.id==item.id){
              questao={...item};
            }
          }
          return item;
        });
        this.setState((prevState) => ({
          questoes,
          questao,
          novoComentario: "",
          loadingAddComent:false
        }));
      }
      
    } catch (error) { }
  };

  openModal = (questao) => {
    console.log(questao)
    this.setState({ isModalOpen: true, questao:questao,status:questao.statusAprovacao ?? '', isModalLoading: false });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleNovoComentarioChange = (event) => {
    this.setState({ novoComentario: event.target.value });
  };

  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };

  handleSubmitStatus = () => {
    this.editStatusQuestao(this.state.status, this.state.questao);
    this.closeModal();
  };

  handleSubmitComentario = () => {
    this.handleAddComentario(this.state.questao.id);
  };
  handleTableUpdate = () => {
  };

  render() {
    const {
      redirect,
      loading,
      isModalOpen,
      isCommentsLoading,
      questao,
      novoComentario,
      status,
      showSuccessModal,
      isModalLoading,
      statusMsg,
      loadingAddComent,
      loadingStatus,
      statusFilter
    } = this.state;

    const questoesFiltradas = this.state.questoes;

    if (redirect) {
      return <Redirect to="/error" />;
    }

    return (
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body" id="card">
              <h4 className="mt-0 header-title">{this.context.t('legacy_lista_de_questoes_para_avaliacao')}</h4>
              <p>{this.context.t('legacy_aqui_sao_listados_todas_as_questoes_pendentes_do_seu_sistema')}</p>
              <div className="row">
                <div className="flex jcsb flex-wrap mb-1">

                  <Search placeholder={this.context.t('legacy_pesquisar_pelo_enunciado_ou_nome_do_elaborador')} ValueChange={value => {
                    clearTimeout(this.pesquisarTimeout);
                    this.pesquisarTimeout = setTimeout(() => {
                      let page = { ...this.state.pagination };
                      page.current_page = 1;
                      this.setState({ pagination: page, search: value, loading: true });
                      this.fetchQuestoes(1, value);
                    }, 2000);
                  }} />


                  




                </div>
                <div className="flex flex-wrap">
                  <strong>{this.context.t('label_status')}:&nbsp;&nbsp;&nbsp;</strong>
                  {["pendente","aprovado", "recusado","all"].map((option) => (
                    <div
                      key={option}
                      className="form-check align-items-center mb-2 me-4"
                    >
                      <input
                        type="radio"
                        name={"dsada"+option}
                        id={"dsada"+option}
                        className="form-check-input me-2"
                        value={option}
                        checked={statusFilter === option}
                        onChange={(e)=>this.setState({statusFilter:e.target.value,loading:true},()=>{
                          this.fetchQuestoes(this.state.pagination.page,this.state.search)
                        })}
                      />
                      <label htmlFor={option} className="form-check-label">
                        {option === "pendente" ? this.context.t('status_pending') : (option === "aprovado" ? this.context.t('status_approved') : (option === 'recusado' ? this.context.t('status_rejected') : this.context.t('option_all_feminine')))}
                      </label>
                    </div>
                  ))}
                  </div>

                {loading ? (
                  <div className="d-flex justify-content-center">
                    <CircularProgress />
                  </div>
                ) : (
                  <div >

                    {questoesFiltradas.length === 0 ? (
                      <div className="work-queue-empty">{this.context.t('empty_no_questions_found_dot')}</div>
                    ) : (
                      <div className="work-queue work-queue-reviews">
                        {questoesFiltradas.map((questao) => {
                          const questionType = questao.type_questao == 'simples'
                            ? this.context.t('question_multiple_choice')
                            : questao.type_questao == 'conjunto'
                              ? `${this.context.t('question_group_prefix')} - ${questao.questoes.length} ${this.context.t('question_plural')}`
                              : this.context.t('question_discursive');

                          return (
                            <WorkQueueItem
                              key={questao.id}
                              icon={<MdRateReview />}
                              eyebrow={questionType}
                              title={questao.text_questao}
                              meta={[
                                { label: this.context.t('label_subject'), value: questao.categoria.name },
                                { label: this.context.t('legacy_nome_do_elaborador'), value: questao.user.name },
                                { label: this.context.t('legacy_identificador_da_demanda'), value: `#${questao.demanda.id}` },
                                { label: this.context.t('legacy_data_da_ultima_atualizacao'), value: formatDate(questao.updated_at) },
                              ]}
                              status={<StatusBadge {...getApprovalStatus(questao.statusAprovacao)} />}
                              actions={(
                                <>
                                  <Link className="work-queue-action-button secondary" to={`/avaliar-questoes/show/${questao.id}`}>
                                    <BsFillEyeFill />
                                    <span>{this.context.t('action_manage_question')}</span>
                                  </Link>
                                  <button type="button" className="work-queue-action-button" onClick={() => this.openModal(questao)}>
                                    <FaStar />
                                    <span>{this.context.t('action_review_question')}</span>
                                  </button>
                                </>
                              )}
                            />
                          );
                        })}
                      </div>
                    )}
                    <Pagination
                      className={(this.state.pagination.last_page == 1 ? "hide" : "")}
                      style={{ display: "flex", justifyContent: "flex-end" }}
                      count={this.state.pagination.last_page}
                      value={this.state.pagination.current_page}
                      onChange={(_, value) => {
                        console.log(_, value);
                        let page = { ...this.state.pagination };
                        page.current_page = value;
                        this.setState({ pagination: page, loading: true });
                        this.fetchQuestoes(value, this.state.search);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div hidden id="text_enunciado">

</div>
        <Modal show={isModalOpen} onHide={this.closeModal} centered>
          <Modal.Header closeButton>
            <Modal.Title className="fs-5 fw-bold">{this.context.t('title_review_question')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {isModalLoading ? (
              <div className="d-flex justify-content-center">
                <CircularProgress />
              </div>
            ) : (
              <>
                <div id="avaliacao_header" className="mb-4">
                {statusMsg != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                <div className="alert alert-danger alert-dismissible fade show mb-0 w-100" role="alert">
                  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label={this.context.t('action_close')} onClick={() => this.setState({statusMsg:''})}></button>


                  <p style={{ marginBottom: 0, whiteSpace: 'pre' }}>{statusMsg}</p>

                </div>
                <br />

              </div>}
                  <h6 className="fw-semibold text-dark mb-3">{this.context.t('label_comments')}</h6>
                  {isCommentsLoading ? (
                    <p className="text-muted text-center">
                      {this.context.t('loading_comments')}
                    </p>
                  ) : (
                    <ul className="list-unstyled">
                      {questao?.comentarios?.length==0 && <li>{this.context.t('empty_no_comments')}</li>}
                      {questao?.comentarios?.map((comentario, index) => (
                         <li
                         key={index}
                         className="d-flex align-items-center mb-3"
                         style={{ cursor: "pointer" }}
                       >
                         <div className="me-3">
                           <FaUserCircle className="fs-4 text-muted" />
                         </div>
                         <div className="flex-grow-1">
                           <OverlayTrigger
                             placement="top"
                             overlay={
                               <Tooltip id={`tooltip-${index}`}>
                                  {this.context.t('label_created_at_colon')} {formatDate(comentario.created_at)}
                               </Tooltip>
                             }
                           >
                             <div className="d-flex justify-content-between align-items-center">
                               <strong className="text-muted me-2">
                                 {comentario.user_name}
                               </strong>
                               <small className="text-muted">
                                 {formatDate(comentario.created_at)}
                               </small>
                             </div>
                           </OverlayTrigger>
                           <p className="mb-0 text-dark">{comentario.comentario}</p>
                         </div>
                       </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="mb-4">
                  <h6 className="fw-semibold text-dark mb-3">
                    {this.context.t('action_add_comment')} <Attention />
                  </h6>
                  <textarea
                    className="form-control mb-2"
                    value={novoComentario}
                    onChange={this.handleNovoComentarioChange}
                    placeholder={this.context.t('placeholder_write_comment')}
                  />
                  <div className="d-flex justify-content-end mt-2">
                  {loadingAddComent == false ? <DefaultButton
                    bg="info"
                    icon={<MdSaveAlt/>}
                    text={this.context.t('action_save_comment')}
                    onClick={()=>this.handleSubmitComentario()}
                  >
                    
                  </DefaultButton> : <CircularProgress />}
                  </div>
                </div>

                <div className="mb-4">
                  <h6 className="fw-semibold text-dark mb-3">{this.context.t('label_review')}</h6>
                  {["aprovado", "recusado"].map((option) => (
                    <div
                      key={option}
                      className="d-flex align-items-center mb-2"
                    >
                      <input
                        type="radio"
                        id={option}
                        className="form-check-input me-2"
                        value={option}
                        checked={status === option}
                        onChange={this.handleStatusChange}
                      />
                      <label htmlFor={option} className="form-check-label">
                        {this.context.t(option === "aprovado" ? 'action_approve' : 'action_reject')}
                      </label>
                    </div>
                  ))}
                </div>

                <div className="d-flex justify-content-end">
                  {loadingStatus==false ?<DefaultButton
                                            bg="confirm"
                  text={this.context.t('action_submit_review')}

                  icon={<RiSendPlaneLine />}

                  onClick={() => this.handleSubmitStatus()}
                >
                </DefaultButton>:<CircularProgress/>}
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        <SuccessModal
          t={this.context.t}
          show={showSuccessModal}
          handleClose={() => this.setState({ showSuccessModal: false })}
          handleTableUpdate={this.handleTableUpdate}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.AppReducer.user,
  token: state.AppReducer.token,
});

export default connect(mapStateToProps, { logout })(AvaliarQuestoes);
